export const version = "signing-key/5.0.10";
//# sourceMappingURL=_version.js.map